import { type Device } from '@pitbrain/shared'
import useApi from '../../../api/useApi'
import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { GPS_ONLY_FEATURES, useCreateSession } from '../useCreateSession'
import { rawTelemetryFromKmhRows } from '../gpsReadings'
import { type UploadFormat } from '../UploadFormat'

const I2M: Device = { name: 'I2M', version: '1.0' }

export const useI2mProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const createSession = useCreateSession(api)

  const processFile = async (file: File, sessionId: string): Promise<void> => {
    const results = await api.fileApi.convertDatFile(file)
    const rawTelemetry = rawTelemetryFromKmhRows(results, I2M)
    await createSession(rawTelemetry, {
      sessionId,
      fileName: file.name,
      device: I2M,
      sessionFeatures: GPS_ONLY_FEATURES,
    })
  }

  return {
    extensions: ['.DAT'],
    keepsFileAsSource: true,
    processFile,
    error: api.error,
  }
}
